/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { compose } from "recompose";
import { Flex, Box as OriginalBox } from "grid-styled";
import { display } from "styled-system";
import styled, { css } from "styled-components";
import FA from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/fontawesome-free-solid";
import logo from "./biofit-white-logo.svg";
import { Container } from "../Grid";
import withToggle from "../withToggle";
import { Body } from "../TextStyles";

const Box = OriginalBox.extend`
  ${display};
`;

const Logo = styled.img`
  height: 40px;
  width: auto;
`;

const Upper = Box.extend`
  background: ${({ theme }) => theme.secondary};
  padding: 0;
  @media print {
    display: none;
  }
`;

const Lower = styled.div`
  background: ${({ theme }) => theme.primary};
  color: white;
  a {
    color: white;
    text-transform: uppercase;
  }
`;

const UpperLink = styled.a`
  color: white;
  background-color: ${({ theme }) => theme.primary};
  height: 100%;
  padding: 10px 20px;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
  text-transform: uppercase;
`;
const LowerLink = styled.a`
  font-size: 1rem;
  font-weight: 600;
  margin-right: 3rem;
  &:last-child {
    margin-right: 0;
  }
`;

const HamburgerLink = styled.a`
  padding: 1rem;
  font-size: 1.2rem;
  transition: all 0.3s ease-out;
  cursor: pointer;
  :hover {
    background: #ccc;
  }
  @media print {
    display: none;
  }
`;

const Hamburger = (props) => {
  const { toggleMobileMenuShow } = props;
  return (
    <HamburgerLink onClick={toggleMobileMenuShow}>
      <FA icon={faBars} />
    </HamburgerLink>
  );
};

const MobileMenuWrapper = styled.ul`
  opacity: 0;
  max-height: 0;
  height: auto;
  transition: all 0.3s ease-out;
  padding: 0 0 1rem 0;
  margin: 0;
  list-style: none;
  display: none;

  ${({ visible }) =>
    visible &&
    css`
      display: block;
      opacity: 1;
      max-height: 200px;
    `};
`;

const LI = styled.li`
  margin: 0.5rem 0 0.5rem 1rem;
`;

const MobileMenu = ({ mobileMenuShow }) => {
  return (
    <MobileMenuWrapper visible={mobileMenuShow}>
      <LI>
        <a target="_blank" href="https://www.biofit.com">
          Main BioFit Site
        </a>
      </LI>
      <LI>
        <a target="_blank" href="https://www.biofit.com/about">
          About BioFit
        </a>
      </LI>
      <LI>
        <a target="_blank" href="https://www.biofit.com/literature">
          Literature
        </a>
      </LI>
      <LI>
        <a target="_blank" href="https://www.biofit.com/contact">
          Contact BioFit
        </a>
      </LI>
    </MobileMenuWrapper>
  );
};

const Header = (props) => {
  return (
    <header>
      <Upper display={["none", "block"]}>
        <Container>
          <Flex justifyContent="flex-end">
            <UpperLink target="_blank" href="https://www.biofit.com">
              Main BioFit Site
            </UpperLink>
          </Flex>
        </Container>
      </Upper>
      <Lower>
        <Container>
          <Flex alignItems="center" justifyContent="space-between">
            <Box width={[1, 1 / 3, 1 / 2]} p="1.2rem 0">
              <Link to="/">
                <Logo src={logo} alt="BioFit" />
                <Body
                  style={{ color: "white", fontSize: "16px", fontWeight: 700, lineHeight: "18px" }}
                >
                  Chair Builder
                </Body>
              </Link>
            </Box>
            <Box display={["none", "block"]} width={[1, 2 / 3, 1 / 2]}>
              <Flex alignItems="center" justifyContent="flex-end">
                <LowerLink target="_blank" href="https://www.biofit.com/about">
                  About BioFit
                </LowerLink>
                <LowerLink target="_blank" href="https://www.biofit.com/literature">
                  Literature
                </LowerLink>
                <LowerLink target="_blank" href="https://www.biofit.com/contact">
                  Contact BioFit
                </LowerLink>
              </Flex>
            </Box>
            <Box display={["block", "none"]}>
              <Hamburger {...props} />
            </Box>
          </Flex>
          <MobileMenu {...props} />
        </Container>
      </Lower>
    </header>
  );
};

export default compose(
  withRouter,
  withToggle({ name: "mobileMenu", trueName: "show", falseName: "hide" })
)(Header);
